import { useAiApiClient } from "#lib/AiApiClient.ts";
import { AiQueryKeys } from "#lib/AiQueryKeys.ts";
import { useSuspenseQuery } from "@tanstack/react-query";

export const useGetChannelsDetailsSuspenseQuery = () => {
    const client = useAiApiClient();

    return useSuspenseQuery({
        queryKey: AiQueryKeys.GetChannelsDetails(),
        queryFn: async() => {
            const data = await client.getChannelsDetails();

            return data;
        },
        // Refresh connection status when the user returns to the tab (e.g. after connecting an app in the
        // management app). staleTime: 0 is required too, since refetchOnWindowFocus only refetches a stale
        // query and the global 5-minute staleTime would otherwise suppress it.
        refetchOnWindowFocus: true,
        staleTime: 0
    });
};
